/**
 * This is used to override the origin of the client.
 * This is mainly used when running MCP Apps where the app is hosted in a different origin and we need to repoint requests to our app
 */
let origin: URL | undefined = undefined;

export const getOriginOverrideUrlObject = (): URL | undefined => origin;

export const setOriginOverrideUrlObject = (newOrigin: URL): void => {
  origin = newOrigin;
};
